import { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const DAY = 864e5;
const WINDOW = 30 * 6e4;
const pad = (n) => String(n).padStart(2, "0");

const fmt = (ms) => {
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  return `${h ? `${h}h ` : ""}${pad(Math.floor((s % 3600) / 60))}m ${pad(s % 60)}s`;
};

export const CallCountdown = ({ at }) => {
  const [t, setT] = useState(Date.now());
  useEffect(() => { const i = setInterval(() => setT(Date.now()), 1000); return () => clearInterval(i); }, []);
  const left = new Date(at).getTime() - t;
  if (left > DAY || left < -WINDOW) return null;
  const live = left <= 0;
  return (
    <p className={`mt-2 inline-flex items-center gap-2 rounded-full px-3 py-1 text-sm font-semibold ${live ? "animate-pulse bg-primary text-primary-foreground" : "bg-primary/15 text-primary"}`} data-testid="group-call-countdown" aria-live="polite">
      <Timer className="h-4 w-4" aria-hidden />{live ? "Starting now" : `Starts in ${fmt(left)}`}
    </p>
  );
};
